import script from "./PersonalStatisticsProgressViewTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalStatisticsProgressViewTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./PersonalStatisticsProgressViewTableLoader.vue?vue&type=style&index=0&id=2457e2de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2457e2de"]])

export default __exports__